import { ArrowUpRight } from 'lucide-react'
import { useState } from 'react'
import { useModal } from '../../contexts/ModalContext'
import FormularioRD from '../../rdstation/formularioRD'
import { cn } from '../../utils/cn'
import Container from '../container'

export default function Diferenciais() {
  const [activeItem, setActiveItem] = useState()
  const { openModal } = useModal()
  const items = [
    {
      id: 1,
      icon: '../assets/icones/ia/eficiencia.svg',
      title: 'Eficiência operacional aumentada',
      description:
        'Automatizamos tarefas repetitivas e processos complexos para que sua equipe possa se concentrar em atividades estratégicas, aumentando a produtividade e reduzindo custos.',
    },
    {
      id: 2,
      icon: '../assets/icones/ia/seguranca.svg',
      title: 'Segurança e conformidade garantidas',
      description:
        'Desenvolvemos soluções com foco em segurança e aderência às regulamentações, assegurando que todos os dados tratados pela IA permaneçam protegidos e sigilosos.',
    },
    {
      id: 3,
      icon: '../assets/icones/ia/integracao.svg',
      title: 'Integração inteligente de assistentes virtuais',
      description:
        'Aprimoramos a experiência do usuário e otimizamos os processos internos através da implementação de assistentes virtuais personalizados, que fornecem suporte ágil e eficiente no atendimento ao cliente.',
    },
    {
      id: 4,
      icon: '../assets/icones/ia/agilidade.svg',
      title: 'Agilidade e inovação no negócio',
      description:
        'Realizamos a implementação de IA e ML para permitir que sua empresa inove com rapidez, respondendo às mudanças do mercado com agilidade e potencializando a competitividade.',
    },
  ]

  return (
    <section className="bg-[url(../assets/cover-proposito.png)] bg-cover bg-no-repeat text-white">
      <Container className="pt-14 pb-24 lg:pt-40 lg:pb-60 flex flex-col lg:flex-row justify-between gap-14 lg:gap-36">
        <article className="space-y-7">
          <h3 className="font-inter-light text-4xl md:text-5xl text-center">
            Diferenciais
          </h3>

          <div className="relative overflow-hidden flex items-center justify-center">
            <img
              src="../assets/data-diferencial.png"
              alt=""
              className="block w-full lg:min-w-[359px]"
            />
            <div className="bg-[rgba(66,19,147,0.7)] rounded-[25px] py-4 px-5 flex items-center gap-6 absolute bottom-0 mb-4">
              <h3 className="font-inter-light w-full">
                Otimize <br /> seu negócio!
              </h3>

              <button
                type="button"
                onClick={() => openModal(<FormularioRD />)}
                className="flex items-center gap-2 py-2 px-8 rounded-full bg-gradient-to-r from-[rgba(252,0,33,1)] to-[rgba(85,52,217,1)] hover:scale-105 transition-transform duration-300 cursor-pointer"
              >
                Contratar <ArrowUpRight />
              </button>
            </div>
          </div>
        </article>
        <article>
          <div>
            {items.map((item, index) => (
              <div
                key={index}
                className="border-t border-[#FC0021] py-6"
                onClick={() => setActiveItem(index)}
              >
                <div className="flex items-center justify-between cursor-pointer gap-5">
                  <div className="flex items-center gap-4">
                    <img src={item.icon} alt="" />
                    <h3
                      className={cn(
                        'text-white font-inter-light text-sm uppercase md:text-xl tracking-wider',
                        activeItem === index && 'font-inter-bold',
                      )}
                    >
                      {item.title}
                    </h3>
                  </div>

                  <button
                    type="button"
                    className={`size-8 aspect-square rounded-full flex items-center justify-center transition-colors ${
                      activeItem === index ? 'bg-[#FC0021]' : ''
                    }`}
                  >
                    {activeItem === index ? (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>chevron</title>
                        <path
                          d="M7 0L13.9282 7.5H0.0717969L7 0Z"
                          fill="white"
                        />
                      </svg>
                    ) : (
                      // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-180"
                      >
                        <path
                          d="M7 0L13.9282 7.5H0.0717969L7 0Z"
                          fill="white"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    activeItem === index
                      ? 'max-h-[200px] opacity-100'
                      : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="mt-4 pl-10 text-white text-xs md:text-base lg:text-xl pr-8 font-inter-light">
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </article>
      </Container>
    </section>
  )
}
